<style scoped>
    @import url("../../../styles/smartControl/defGeralSC.scss");
</style>

<template>
    <div class="box_defGeralSC2">

        <!-- gambiarra temporária 
        <div :style="{'color':'#395872'}">12345</div>-->

        <div class="macro_el">
            <div class="tit ml-2">Horário local</div>

            <div class="painelSearch">

                <div class="searchBar mt-1 mb-1">

                    <v-autocomplete
                    v-model="hhmmSelected"
                    :items="liHorariosLocais"
                    color="rgb(247,215,46)"
                    class="w-100"
                    @update:modelValue="trocarHorarioLocal"
                    ></v-autocomplete>
                </div>
            </div>

            <v-btn v-if="flagBtnUp"
            class="mt-2"
            color='green'
            block 
            :disabled="!flagBtnUp"
            @click="callFather()"
            >
                Atualizar
            </v-btn>
        </div>

    </div>
</template>

<script>

export default {

    props:['agent_unit'],

    data() {
        return {

            // search bar
            liHorariosLocais:["Europe/Lisbon","Europe/Madrid"], // front hardcode
            hhmmSelected:'Europe/Lisbon', // default
            estruturaLocal:{},
            flagBtnUp:false, // controle do botão de atualização
            fusoInit:'Europe/Lisbon', // default
        }
    },

    methods:{

        trocarHorarioLocal(fusoSelectedFromFront) {
            //console.log('hhmmLocal: ',fusoSelectedFromFront)
            this.hhmmSelected = fusoSelectedFromFront // up local exib

            // -- SE houve alteração então req up.
            //console.log('[fusoSC][trocarHorarioLocal] this.fusoInit: ',this.fusoInit)
            //console.log('[fusoSC][trocarHorarioLocal] fusoSelectedFromFront: ',fusoSelectedFromFront)
            if (this.fusoInit != fusoSelectedFromFront) { this.flagBtnUp = true }
            else { this.flagBtnUp = false }
        },

        callFather() {
            // --> enviar para db
            // <-- após confirmação, atualizar storage
            // refresh
            // -- componente pai trata a requisição de update.
            // --- pai espera o doc completo.
            this.estruturaLocal['fuso_horario'] = this.hhmmSelected // string
            //console.log('[fusoSC] estruturaLocal: ',this.estruturaLocal)
            this.$emit('fromChildUpFuso', this.estruturaLocal) // dict
        },
    },

    created() {
        //window.scrollTo(0,0)

        // buscar horários locais disponíveis no db?
        //console.log('[fusoSC] fuso:',this.agent_unit['estrutura']['fuso_horario'])
        this.hhmmSelected = this.agent_unit['estrutura']['fuso_horario'] // string
        this.fusoInit = this.hhmmSelected
        this.estruturaLocal = this.agent_unit['estrutura']
    }
}
</script>